import { EnumBuilder } from '@bazaar-marketplace/utils';

export const partnerMarketplaceEnum = new EnumBuilder<{
  name: string;
  url: string | null;
  logoSrc: string;
  comingSoon?: boolean;
  onChainEnabled?: boolean;
}>().build({
  getgems: {
    name: 'Getgems',
    url: 'https://getgems.io',
    logoSrc: '/assets/partner-marketplaces/getgems.png',
    onChainEnabled: true,
  },
  palacenft: {
    name: 'Palace Market',
    url: 'https://t.me/palacenftbot/?startapp=to_goodies',
    logoSrc: '/assets/partner-marketplaces/palace-nft.png',
  },
  laffka: {
    name: 'Laffka NFT',
    url: 'https://t.me/LaffkaStickerBot?startapp',
    logoSrc: '/assets/partner-marketplaces/laffka.png',
    onChainEnabled: true,
  },
});
